export const formatsToUpload = [
    'png',
    'jpeg',
    'gif',
    'jpg',
    'doc',
    'docx',
    'odt',
    'xls',
    'xlsx',
    'pdf',
    'csv',
    'rtf',
    'heic',
    'heif'
];
